import { render, staticRenderFns } from "./BaseMultipleSelect.vue?vue&type=template&id=72d98d5a&"
import script from "./BaseMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleSelect.vue?vue&type=style&index=0&id=72d98d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports